<template>
  <div class="category-list">
    <div class="category-list-body">
      <div class="category-list-border">
        <div class="category-list-scroll" v-if="rearrange.active" :style="{ 'padding-bottom': '0vw' }"
          ref="categoryScroll">
          <draggable :list="rearrangedCategories" chosen-class="rearrange-ghost">
            <CategoryListRow v-for="(category, index) in menu.categories" :key="category._id" :index="index"
              :title="category.name" :state="'rearrange'" :count="getCategoryDishCount(category)" />
          </draggable>
        </div>
        <div class="category-list-scroll" id="scroll" v-if="!rearrange.active">
          <!-- <CategoryListRow
            :title="$t('menu_settings.recomendations')"
            :count="exclusivesList.length"
            :index="0"
            :state="exclusives_category ? 'selected' : 'default'"
            isExclusive
            @click="exclusives_category = true"
          /> -->

          <!-- Iterate category list -->
          <CategoryListRow v-for="(category, index) in menu.categories" :key="category._id" :index="index"
            :placeholder="isLocalizing ? category.name : null"
            :title="isLocalizing ? category.i18n[currentLocale] || null : category.name"
            :state="getCategoryRowState(category, index)" :count="getCategoryDishCount(category)"
            :untranslated="isLocalizing && isUiMenuTranslationPreviewed && !category.i18n[currentLocale]"
            @click="onCategorySelect(index)" @rename="onEditCategory" />


          <div :class="{
          'category-list-item': true,
        }" v-forff="(category, index) in menu.categories" :key="index" v-if="false">
            <!-- If we are editing current category, show edit card instead -->
            <div v-if="edit_category.active && index === currentCategoryIndex">
              <form class="category-new" v-if="edit_category.active" @submit.prevent="onEditCategory">
                <input type="text" class="category__title__edit" id="editCategoryInput" placeholder="Name" required
                  v-model="edit_category.name" v-if="!isLocalizing" />
                <input type="text" class="category__title__edit" id="editCategoryInput"
                  :placeholder="menu.categories[index].name" required
                  v-model="menu.categories[index].i18n[currentLocale]" v-else-if="isLocalizing" />
                <!-- <p @click="showDeleteUI">{{ $t("category_list.delete") }}</p> -->
                <button class="submit" type="submit"></button>
                <button @click="hideEditCategoryUI" class="cancel"></button>
              </form>
            </div>

            <!-- Else, display normal card -->
            <div v-else>
              <div class="category" @click="onCategorySelect(index)" :class="{
          'category-selected':
            currentCategoryIndex === index &&
            !exclusives_category &&
            !modificatorsCategorySelected,
        }">
                <div class="category-info">
                  <h3 :class="{
          'not-translated':
            isLocalizing && !category.i18n[currentLocale],
        }" :style="{
          color:
            isLocalizing && !category.i18n[currentLocale]
              ? '#e2223b !important'
              : '',
        }">
                    {{
          isLocalizing && category.i18n[currentLocale]
            ? category.i18n[currentLocale]
            : category.name
        }}
                  </h3>
                  <p>
                    {{ getCategoryDishCount(category) }}
                    {{ $t("nouns.dishes") }}
                  </p>
                </div>
                <div class="category-number">
                  <span :class="currentCategoryIndex == index &&
            !exclusives_category &&
            !modificatorsCategorySelected
            ? 'num active'
            : 'num'
          ">{{ index + 1 }}</span>
                </div>
              </div>
            </div>
          </div>

          <CategoryListRow state="edit" title="" :index="menu.categories.length" v-if="add_category.active"
            @rename="onAddCategory" />
        </div>
      </div>

      <div class="buttons-row mt-16" v-if="!hideActions && !busy && !isExampleMenu">
        <BaseButton variant="secondary" color="red-4" size="md" class="mr-8" icon="trash" @click="showDeleteUI"
          v-if="!exclusives_category && menu.categories.length"></BaseButton>
        <BaseButton variant="secondary" color="v1-grey-10" size="md" class="mr-8" icon="move-filled"
          @click="showMoveCategoryUI" v-if="!exclusives_category && menu.categories.length"></BaseButton>
        <BaseButton variant="secondary" color="v1-grey-10" size="md" class="mr-8" icon="list" @click="showRearrangeUI"
          v-if="!exclusives_category && menu.categories.length"></BaseButton>
        <BaseButton variant="secondary" color="v1-grey-10" size="md" class="mr-8" icon="pencil"
          @click="showCategoryEditUI" v-if="!exclusives_category && menu.categories.length"></BaseButton>
        <BaseButton variant="secondary" color="v1-grey-10" size="md" class="mr-8" icon="copy" @click="duplicateCategory"
          v-if="!exclusives_category && menu.categories.length"></BaseButton>

        <BaseButton variant="secondary" color="green-6" icon="plus" class="w-100" size="md" @click="showAddCategoryUI"
          v-if="!hideActions">

        </BaseButton>
      </div>


      <p class="rearrange-buttons mt-16" v-if="rearrange.active">
        <BaseButton color="green-6" size="md" variant="primary" class="w-100" @click="hideRearrangeUI">
          {{ $t("category_list.done") }}
        </BaseButton>
      </p>
    </div>

    <DangerConfirmModal @confirm="onDeleteCategory" @cancel="deleting = false" :title="$t('category_list.delete')"
      v-if="deleting">
      <p class="qrw-paragraph-md v1-grey-3-color">{{ $t("category_list.confirm_delete", {
          name: currentCategory.name
        }) }}</p>
    </DangerConfirmModal>

    <TransferDishModal menu_only @close="moving_category = false" @toMenu="moveCategory" v-if="moving_category" />
  </div>
</template>

<script>
import draggable from "vuedraggable";

import CategoryListRow from "@/components/menu/CategoryListRow.vue"

import TransferDishModal from "@/components/menu/TransferDishModal.vue"

export default {
  data () {
    return {
      currentCategoryIndex: null,
      deleting: false,

      add_category: {
        active: false,
        name: null,
      },
      edit_category: {
        active: false,
        name: null,
        id: null,
      },
      rearrange: {
        active: false,
      },
      moving_category: false,
      moving_busy: false,

      hideActions: false,
      modificatorsCategorySelected: false,
    };
  },
  components: {
    draggable,
    TransferDishModal,
    CategoryListRow
  },
  props: {
    busy: Boolean,
  },
  methods: {
    onCategorySelect (index) {
      this.exclusives_category = false;
      this.currentCategoryIndex = index;
      if (this.edit_category.active) {
        this.edit_category.name = this.currentCategory.name;
      }
      this.$emit("select", this.currentCategory);
      this.modificatorsCategorySelected = false;
      this.$emit("modificatorsCategory", false);
    },

    onExclusivesSelect () {
      this.exclusives_category = true;
      this.modificatorsCategorySelected = false;
      this.$emit("modificatorsCategory", false);
    },

    onModificatorsSelect () {
      this.modificatorsCategorySelected = true;
      this.$emit("modificatorsCategory", true);
    },

    showMoveCategoryUI () {
      this.moving_category = true;
    },

    showRearrangeUI () {
      this.rearrange.active = true;
      this.hideActions = true;
    },

    hideRearrangeUI () {
      this.rearrange.active = false;
      this.hideActions = false;
      this.onCategorySelect(0);

      this.$store.dispatch("menu/save");
    },

    showAddCategoryUI () {
      if (this.add_category.active) {
        this.onAddCategory();
      }

      this.hideActions = false;
      this.edit_category.active = false;
      this.add_category.active = true;
      this.add_category.name = null;

      this.$nextTick(() => {

        this.scrollList();
      });
    },

    scrollList () {
      const scrollContainer = document.getElementById("scroll");

      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    },

    showCategoryEditUI () {
      this.hideActions = true;

      this.add_category.active = false;

      this.edit_category.active = true;
      this.edit_category.name = this.currentCategory.name;
      this.edit_category.id = this.currentCategory._id;

      this.$nextTick(() => {
        document.getElementById("editCategoryInput").focus();
      });

      this.$emit("editCategory");
    },

    hideEditCategoryUI () {
      this.hideActions = false;
      this.edit_category.active = false;
    },

    onAddCategory (_new_name) {
      let name = _new_name;
      if (_new_name === undefined) {
        name = this.$t('category_list.new_category_ph') + ` (${this.menu.categories.length + 1})`;
      } else {
        this.add_category.active = false;
        if (!name) return;
      }

      this.$store
        .dispatch("menu/addCategory", name)
        .then((ok) => {
          this.onCategorySelect(this.menu.categories.length - 1);

          this.$nextTick(() => {
            this.scrollList();
          });
        });
      // this.$store.dispatch("menu/save");
    },

    onEditCategory (title) {
      if (this.isLocalizing) {
        this.$set(
          this.menu.categories[this.currentCategoryIndex].i18n,
          this.currentLocale,
          title
        );
      } else {
        this.$store.commit("menu/editCategory", {
          index: this.currentCategoryIndex,
          name: title,
        });
      }

      this.$store.commit(
        "menu/forceModifyCategoryProducts",
        this.edit_category.id
      );
      this.$store.dispatch("menu/save");

      this.hideEditCategoryUI();
    },

    duplicateCategory () {
      this.$store.dispatch('menu/duplicateCategory', this.currentCategory._id).then(() => {
        this.onCategorySelect(this.menu.categories.length - 1);
        this.$nextTick(() => {
          this.scrollList();
        });
      });
    },

    moveCategory (id) {
      if (this.moving_busy) return;

      this.moving_busy = true;

      const category_name = this.currentCategory.name;
      const menu_id = this.menu._id;

      this.$store.dispatch('menu/moveCategory', {
        category_id: this.currentCategory._id,
        dst_menu_id: id
      }).then(() => {
        this.moving_category = false;

        this.$store.dispatch('menu/fetchMenus');
        this.$store.dispatch("auditlog/write", {
          type: "transfer_menu_category",
          payload: {
            src_menu_id: menu_id,
            dst_menu_id: id,
            category_name
          }
        });
      }).finally(() => {
        this.moving_busy = false;
      });
    },

    getCategoryDishCount (category) {
      return this.$store.getters["menu/productsForCategory"](category).length;
    },

    showDeleteUI () {
      this.deleting = true;
    },

    onDeleteCategory () {
      this.$store.commit("menu/removeCategory", {
        index: this.currentCategoryIndex,
        name: this.edit_category.name,
      });
      this.$store.dispatch("menu/save");
      this.$store.commit("menu/chooseProduct", null);
      this.deleting = false;
      this.$store.dispatch("auditlog/write", {
        type: "remove_menu_category",
        payload: {
          menu_id: this.menu._id,
          menu_title: this.menu.title,
          category_name: this.edit_category.name
        },
      });
      this.hideEditCategoryUI();
      const new_index = this.menu.categories.length
        ? this.menu.categories.length - 1
        : 0;
      this.onCategorySelect(new_index);
    },
    getCategoryRowState (category, index) {
      if (this.edit_category.active && index == this.currentCategoryIndex) {
        return 'edit';
      }

      if (this.currentCategoryIndex == index && !this.exclusives_category) return 'selected';

      return '';
    }
  },
  computed: {
    menu () {
      return this.$store.state.menu.current;
    },
    isExampleMenu () {
      return this.menu.is_example;
    },
    nonExclusiveCategories () {
      return this.menu.categories;
    },
    exclusivesList () {
      return this.$store.getters["menu/exclusivesList"];
    },
    exclusives_category: {
      get () {
        return this.$store.state.menu.exclusives_category;
      },
      set (v) {
        this.$store.commit("menu/changeExclusivesCategory", v);
      },
    },
    isLocalizing () {
      return this.$store.getters["menu/isLocalizing"];
    },
    currentLocale () {
      return this.$store.state.menu.current_locale;
    },
    currentCategory () {
      if (this.currentCategoryIndex == null) return {};

      return this.menu.categories[this.currentCategoryIndex];
    },
    rearrangedCategories: {
      get () {
        return this.$store.state.menu.current.categories;
      },
      set (value) {
        this.$store.commit("menu/setCategories", value);
      },
    },
    modificatorsList () {
      return this.$store.getters["menu/modificatorsList"];
    },
    canModifyCategoryByAction () {
      return this.menu && this.menu.categories && !this.exclusives_category;
    },
    isUiMenuTranslationPreviewed () {
      return this.$store.state.menu.ui_translation_preview;
    },
  },
  mounted () {
    if (this.menu.categories && this.menu.categories.length) {
      this.onCategorySelect(0);
    }

    if (this.$route.query.category_id) {
      const index = this.menu.categories.findIndex(cat => cat._id === this.$route.query.category_id);

      if (index !== -1) {
        this.onCategorySelect(index);
      }
    }
  },
};
</script>

<style scoped>
.buttons-row {
  display: flex;
}

.category-list {
  width: 100%;
  display: block;
}

.category-list-scroll {
  background: var(--v1-grey-10-color);
  height: 56vh;
  overflow-y: auto;
  border-radius: 8px;
}

.rearrange-ghost {
  /* background: #cbd9e6;
  border-bottom: 0.06vw solid #cbd9e6;
  color: #1d1d1b; */
  background: var(--green-6-color);
  color: var(--white-color);
}

.rearrange-ghost div p,
.rearrange-ghost div h3 {
  color: #1d1d1b;
}

.not-translated {
  color: #e2223b !important;
}
</style>
